export enum PROPOSTA_SITUACOES {
	ANDAMENTO = 1,
	APROVADO = 2,
	PENDENTE = 3,
	REPROVADO = 4,
	CANCELADO = 5,
	FINALIZADO = 6,
	EM_ANALISE = 7,
	ANALISE_ATTA = 8,
	ANALISE_BANCO = 9,
	ANALISE_BANCO_DUVIDA = 10,
	NAO_PASSIVEL_DEFESA = 11,
	REVISAO = 12,
	NAO_PROCESSADO_BANCO = 13,
	DIVERGENCIA_CADASTRO = 14,
	NOTAS_DE_EXIGENCIA = 15,
	CARTORIO_EXTERNO = 16,
	APROVADO_CONDICIONADO = 17
}
